
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Input,
} from "@angular/core";
import { AcquisitionTypeDto, CofOStatusDto, GroupDto, IdentityUserDto, LandTitleDto, SubGroupDto, SubSubGroupDto } from "@cradua/data";
import { fromEvent, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  pluck,
  tap,
} from "rxjs/operators";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'cradua-report-search',
  templateUrl: './report-search.component.html',
  styleUrls: ['./report-search.component.scss']
})
export class ReportSearchComponent implements OnInit {

  @Input() subSubGroups: SubSubGroupDto[];
  @Input() subGroups: SubGroupDto[];
  @Input() groups: GroupDto[];
  @Input() landTitle: LandTitleDto[];
  @Input() acquisitionTypes: AcquisitionTypeDto[];
  @Input() cofOStatus: CofOStatusDto[];
  @Input() task: string;
  @Input() view: string;
  @Output() searchEmit = new EventEmitter<any>();
  @Output() emitEvent = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();
  @Output() emitPaymentMethod = new EventEmitter<any>();

  @ViewChild("search", { static: true })
  searchForm: ElementRef;
  searchSubscription$: Subscription;
  filterSubGroup: SubGroupDto[];
  filterSubSubGroup: SubSubGroupDto[];

  selectedGroupId = "";
  selectedSubGroupId = "";
  selectedSubSubGroupId = "";
  isFilter = false;
  isExpanded = true;
  isViewRange = false;
  searchCriteriaForm: FormGroup;
  hideAdvanceSearch = false;
  selectedTabIndex = 0;
  cofOs = ['Yes', 'No'];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.searchCriteriaForm = this.fb.group({
      Group: '',
      SubGroup: '',
      SubSubGroup: '',
      AcquisitionType: '',
      CofOStatusId: '',
      FirstCallDate: '',
      LastCallDate: '',
    });
  }

  ngAfterViewInit(): void {
    this.searchSubscription$ = fromEvent(this.searchForm.nativeElement, "keyup")
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        pluck("target", "value"),
        tap(_ => this.task === 'list' ? null : this.emitTask.emit('list')),
        // filter((searchTerm: string) => searchTerm.length > 2),
        map((value) => value),
      )
      .subscribe((data) => {
        const newData = {
          name: data,
        }
        this.searchEmit.emit(newData)
      });
  }

  filterWithGroupId() {
    this.searchEmit.emit(this.selectedGroupId);
  }

  protected filterById = <T>(id: string, lookupId: string) =>
    (fieldName: T) => fieldName[lookupId] === id;

  onFilterSubGroup(id: string) {
    this.selectedGroupId = id;
    this.filterSubGroup = this.subGroups.filter(
      this.filterById<SubGroupDto>(id, "GroupId"),
    );
  }

  onViewRange() {
    this.isViewRange = !this.isViewRange;
  }

  filterWithSubGroupId() {
    this.searchEmit.emit(this.selectedSubGroupId);
  }

  onFilterSubSubGroup(id: string) {
    this.selectedSubGroupId = id;
    this.filterSubSubGroup = this.subSubGroups.filter(
      this.filterById<SubSubGroupDto>(id, "SubGroupId"),
    );
  }

  onSelectSubSubGroupId(id: string) {
    this.selectedSubSubGroupId = id;
  }

  filterWithSubSubGroupId() {
    this.searchEmit.emit(this.selectedSubSubGroupId);
  }

  createEvent() {
    this.emitTask.emit('create')
  }

  onPaymentMethod(value) {
    // console.log('payment method ', value)
    this.emitPaymentMethod.emit(value);
  }

  onFilter() {
    this.isFilter = !this.isFilter;
  }

  tabChanged(tabChangeEvent): void {
    // console.log('tabChangeEvent => ', tabChangeEvent);
    // // this.selectedTabIndex = 7;
    // console.log('index => ', tabChangeEvent);
  }

  onSearch(formValue) {

    const value = Object.assign({}, formValue);
    // value['type'] = 'groundRent';
    let transformValue = {};
    if(formValue['Group']) {
      transformValue['GroupId'] = formValue['Group'];
    }
    if(formValue['SubGroup']) {
      transformValue['SubGroupId'] = formValue['SubGroup'];
    }
    if(formValue['SubSubGroup']) {
      transformValue['SubSubGroupId'] = formValue['SubSubGroup'];
    }
    if(formValue['AcquisitionType']) {
      transformValue['AcquisitionTypeId'] = formValue['AcquisitionType'];
    }
    if(formValue['CofOStatusId']) {
      transformValue['CofOStatusId'] = formValue['CofOStatusId'];
    }

    this.searchEmit.emit(transformValue);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.searchSubscription$) {
      this.searchSubscription$.unsubscribe();
    }
  }
}
